<div class="dialog-container">
  <mat-dialog-content>
    <!-- Selected tags display as chips -->
    <div class="selected-tags-container" (click)="clearSelection($event)">
      <div class="section-label">Product Tags:</div>
      <mat-chip-set class="tag-chip-set">
        <mat-chip
          *ngFor="let tag of selectedTags; trackBy: trackByTagId"
          (removed)="toggleTagSelection(tag, false)"
          (click)="viewTagDetails(tag)"
          removable="true"
          [class.new-tag]="isNewTag(tag)"
          [class.added-tag]="isAddedTag(tag)"
          [class.recently-selected-tag]="
            lastSelectedTagId && tag.id?.toString() === lastSelectedTagId
          "
        >
          {{ tag.name }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-set>
    </div>
    <div
      style="
        margin-top: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
      "
    >
      <mat-form-field
        class="full-width"
        style="margin-bottom: 0"
        subscriptSizing="dynamic"
      >
        <input
          type="text"
          matInput
          [formControl]="tagControl"
          [matAutocomplete]="auto"
          placeholder="Type to see available tags"
          autocomplete="off"
        />
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          type="button"
          (click)="clearInput($event)"
        >
          <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onTagSelected($event)"
        >
          <mat-option
            *ngFor="let tag of filteredTags$ | async"
            [value]="tag"
            [disabled]="isTagSelected(tag)"
          >
            {{ tag.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button
        mat-mini-fab
        style="margin-left: 8px"
        color="primary"
        (click)="createTag()"
        [disabled]="isCreateButtonDisabled()"
        matTooltip="Create new tag"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <mat-form-field class="full-width" style="margin-top: 16px">
      <textarea
        matInput
        [formControl]="descriptionControl"
        [value]="currentDescription"
        placeholder="Enter a description for the tag"
        rows="3"
      ></textarea>
      <mat-error align="start" *ngIf="descriptionControl.invalid"
        >Description must be at least 15 characters long</mat-error
      >
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="!hasChanges()"
    >
      Apply Changes
    </button>
  </mat-dialog-actions>
</div>
